<template>
        <b-form-group
          id="fieldset-horizontal"
          label-cols-sm="4"
          label-cols-lg="3"
          :label="action.name"
          :label-for="action.id"
        >
          <template v-slot:label>
            {{action.name}}
            <span v-if="action.taskOutcomes && action.taskOutcomes[0] && action.taskOutcomes[0].mandatory">*</span>
          </template>

          <div v-for="data in action.taskOutcomes" :key="data.id" >
            <b-input-group>
              <ManualTaskOutcome v-if="slots && slots[data.id]" v-bind:dataslot="slots[data.id]"></ManualTaskOutcome>
            </b-input-group>
          </div>

          <span v-if="action.instructions">{{action.instructions}}</span>

        </b-form-group>
</template>

<script>
import ManualTaskOutcome from '@/components/ManualTaskOutcome'

export default {
  name: 'ManualTaskAction',
  props: ['action'],
  components: {
    ManualTaskOutcome
  },
  computed: {
    slots () {
      if( this.$store.state.dialogState ) {
        return this.$store.state.dialogState.slots;
      } else {
        return null;
      }
    }
  },
  methods: {
    selectSuggestion(data, value) {
      document.getElementById(data.id).value=value;
      document.getElementById(data.id).classList.add("is-valid");
    }
  },
  mounted() {

  }
}
</script>

<style scoped>

</style>
